import type { ReactNode } from 'react';
import { Link } from 'react-router';

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  back?: { to: string; label: string };
}

export function PageHeader({ title, description, actions, back }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div className="page-header__text">
        {back && (
          <Link className="page-header__back" to={back.to}>
            <span aria-hidden="true">← </span>
            {back.label}
          </Link>
        )}
        <h1 className="page-title">{title}</h1>
        {description && <p className="page-header__description">{description}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  );
}
